<template>
  <v-app-bar :class="{ 'lightHeader': lightHeader, 'top': !lightHeader }" scroll-behavior="fade-image inverted"
    image="/white.jpg" alt="weiße Kopfzeile" :elevation="0" color="transparent">
    <v-container>
      <v-row tag="nav">
        <v-col cols="auto" style="display: flex;
            align-items: center;
            align-content: center;
            flex-direction: column;
            justify-content: center;
            cursor: pointer">
          <RouterLink to="/" class="headerLogoLink">
            <img src="/logo_light.png" alt="Logo"
              style="height: 50px; width: auto; object-position: left; object-fit: contain" />
          </RouterLink>
        </v-col>

        <v-spacer />

        <!-- <v-col cols="auto" class="px-4 hoverable" style="display: flex; align-items: center;
            align-content: center; position: relative;" @click="() => { this.refreshDisplay++ }" v-if="showCart">
          <div style=" position: relative;">
            <v-icon color="light" class="headerNav">mdi-cart</v-icon>
            <div v-if="activeCart"
              style="position: absolute; top: -5px; right: -5px; height: 10px; width: 10px; background-color: rgba(var(--v-theme-primary)); border-radius: 50%;">
            </div>
          </div>
        </v-col> -->
        
        <v-col cols="auto" class="px-4 hoverable" v-for="route in desktopRoutes" :key="route.name || route.path" style="display: flex;
            align-items: center;
            align-content: center;
            flex-direction: column;
            justify-content: center;">
          <RouterLink :to="route.name ? { name: route.name } : route.path" :aria-current="activeRoute === route.name ? 'page' : undefined"
            :style="{ 'font-weight': activeRoute == route.name ? 'bold !important' : 'unset' }" class="headerNav"
            style="font-size:larger; text-decoration: none;">
            {{ $t("routes." + route.name) }}

          </RouterLink>
        </v-col>


        <v-col cols="auto" style="display: flex; align-items: center;" v-if="!username && !isMobile">
          <v-btn class="primaryButton" to="/login">
            <v-icon class="mr-2">mdi-login</v-icon> <span>{{ $t("basics.login") }}</span>
          </v-btn>
        </v-col>
        <v-col cols="auto" style="display: flex; align-items: center;" v-if="username && !isMobile">
          <v-btn flat class="primaryButton" :to="dashboardRoute">
            {{ $t("basics.goToDashboard") }}
          </v-btn>
        </v-col>
        <v-col cols="auto" style="display: flex; align-items: center; cursor: pointer;" v-if="username && !isMobile"
          class="headerNav" @click="logout()">
          <v-icon class="mr-2">mdi-logout</v-icon> {{ $t("basics.logout") }}
        </v-col>

        <v-col v-if="isMobile" style="display: flex; align-items: center;" cols="auto">
          <v-menu v-model="navDrawer" :close-on-content-click="true" transition="v-scale-transition" min-width="auto">
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-icon color="rgb(var(--v-theme-primary))">mdi-menu</v-icon>
              </div>
            </template>

            <v-card flat class="pa-4">
              <div v-for="(route, routeIndex) in routeArray" :key="route.name || route.path" class="hoverable">
                <RouterLink :to="route.name ? { name: route.name } : route.path" :aria-current="activeRoute === route.name ? 'page' : undefined"
                  :style="{ 'font-weight': activeRoute == route.name ? 'bold !important' : 'unset' }"
                  class="headerNav py-2 headerMobileLink" style="font-size:larger; text-decoration: none;">
                  {{ $t("routes." + route.name) }}

                </RouterLink>
                <v-divider v-if="routeIndex < routeArray.length - 1" />
              </div>

              <div style="display: flex; align-items: center;" v-if="!username">
                <v-btn flat class="primaryButton" to="/login">
                  <v-icon class="mr-2">mdi-login</v-icon> <span>{{ $t("basics.login") }}</span>
                </v-btn>
              </div>
              <div style="display: flex; align-items: center;" v-if="username">
                <v-btn class="primaryButton" :to="dashboardRoute" flat>
                  {{ $t("basics.goToDashboard") }}
                </v-btn>
              </div>
              <div style="display: flex; align-items: center; cursor: pointer;" v-if="username"
                class="headerNav mt-4" @click="logout()">
                <v-icon class="mr-2">mdi-logout</v-icon> {{ $t("basics.logout") }}
              </div>
            </v-card>
          </v-menu>
        </v-col>

      </v-row>
    </v-container>
  </v-app-bar>
  <shopping-cart :refreshDisplay="refreshDisplay" />
</template>

<script>
import { routes } from "../../router/index.js";
import ShoppingCart from "../shop/ShoppingCart.vue";

export default {
  name: "headerLandingComponent",

  data() {
    return {
      routeArray: [],
      routeName: "landingpage",
      scrollY: 0,
      refreshDisplay: 0,

      navDrawer: false
    };
  },

  components: {
    ShoppingCart
  },

  computed: {
    desktopRoutes() {
      return this.isMobile ? [] : this.routeArray;
    },
    dashboardRoute() {
      const firstRoute = String(this.$store.state.avail_routes || "")
        .split(",").map(value => value.trim()).find(Boolean);
      return firstRoute ? "/" + firstRoute + "/dashboard" : "/";
    },
    activeRoute() {
      return this.$route.name
    },
    lightHeader() {
      const path = this.$route.path.replace(/\/+$/, "") || "/";
      if(
        path != "/" &&
        path != "/eigenewege" &&
        path != "/kontakt"
      ){
        return true
      }

      return this.scrollY >= 50
    },
    isDarkTheme() {
      return this.$vuetify.theme.global.current.dark;
    },
    username() {
      return this.$store.state.name;
    },
    activeCart() {
      return this.$store.state.shopping_cart_items && this.$store.state.shopping_cart_items.length > 0;
    },
    showCart() {
      return this.$route.path.includes("shop") || this.activeCart
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },

  methods: {
    handleScroll() {
      this.scrollY = window.scrollY
    },
    logout() {
      this.$store.dispatch("logoutUser").catch((e) => {
        window.location.reload();
      });
    },
    inCheckoutProcess() {
      const checkoutProcess = JSON.parse(localStorage.getItem("in_checkout_process"))
      if (checkoutProcess && !!checkoutProcess) {
        this.refreshDisplay++
      }
    }
  },

  mounted() {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].name == this.routeName) {
        let temp = routes[i].children;

        this.routeArray = []

        for (let j = 0; j < temp.length; j++) {
          if (temp[j].props && temp[j].props.displayInNavigation) {
            this.routeArray.push(temp[j])
          }
        }

        break;
      }
    }

    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.inCheckoutProcess()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
};
</script>

<style>
.headerLogoLink {
  display: inline-flex;
  align-items: center;
}

.headerMobileLink {
  display: block;
}

.headerNav:focus-visible, .headerLogoLink:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 4px;
}

.lightHeader .headerNav {
  color: rgb(var(--v-theme-on-surface)) !important;
}

.top .headerNav {
  color: rgb(var(--v-theme-light)) !important;
}
</style>